import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PlantServiceService } from '../../../../../services/dashboard/solar/plant-service.service';
import {Subscription, timer, Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent} from 'rxjs';
import {Constants} from 'src/app/shared/index';
@Component({
  selector: 'app-plant-key',
  templateUrl: './plant-key.component.html',
  styleUrls: ['./plant-key.component.scss']
})
export class PlantKeyComponent implements OnInit, AfterViewInit, OnDestroy {
siteId: string;
sensorHealth = '';
sensorHealthMsg = '';
plantStartTime = '';
operatingHours = '';
plantStopTime = '';
sysHealthColor = '';
iconPlantKey = false;
  constructor(private plantService: PlantServiceService, private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    const self = this;
    this.plantService.getSolarConfigSubject().subscribe((solarConfig) => {
      this.siteId = solarConfig.siteId;
      this.plantService.getSensorHealthBasedOnLevel(solarConfig.siteId, 'Dashboard').subscribe(
        data => {
          if (data.High > 0) {
            this.sensorHealth = Constants.SENSOR_HEALTH.OFF;
            this.sensorHealthMsg = Constants.SENSOR_HEALTH.NOT_OK;
          } else if (data.Medium > 0) {
            this.sensorHealth = Constants.SENSOR_HEALTH.NA;
            this.sensorHealthMsg = Constants.SENSOR_HEALTH.NOT_OK;
          } else {
            this.sensorHealth = Constants.SENSOR_HEALTH.ON;
            this.sensorHealthMsg = Constants.SENSOR_HEALTH.OK;
          }
          this.sysHealthColor = this.sensorHealth === Constants.SENSOR_HEALTH.ON ? 'dot-green' : this.sensorHealth === Constants.SENSOR_HEALTH.NA ? 'dot-orange' : 'dot-red';
        }
       );
      this.plantService.getPlantKeyOperationData(solarConfig.siteId).subscribe(
        data => {
          this.plantStartTime = data.plantStartTime;
          this.operatingHours = data.operatingHours;
          this.plantStopTime = data.plantStopTime;
        }
       );
    });
  }
  ngAfterViewInit() {
    this.cd.detectChanges();
}
ngOnDestroy() {
 // this.subscription.unsubscribe();
}
public click = () => {
  this.iconPlantKey = !this.iconPlantKey;
}
}
